/* eslint-disable camelcase */

import { SourcingService } from 'api-clients/monolith';

type updateHiringGoalTargetsParams = {
  openingSlug: string;
  requestBody: {
    budget_allotted?: number;
    expected_conversion?: number;
    expected_cpa?: number;
  };
};

export function updateHiringGoalTargets(params: updateHiringGoalTargetsParams) {
  const { openingSlug, requestBody } = params;

  return SourcingService.patchInternalApiSourcingDashboard(
    openingSlug,
    requestBody,
  );
}
